// openEHR AM model — BMM package org.openehr.am.aom2.rm_overlay
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../base/mod.ts";

/**
 * Definition of visibility of an RM attribute within a larger archetype structure.
 */
export class RM_ATTRIBUTE_VISIBILITY {
  /**
   * Visibility setting of a non-archetyped RM attribute (RM attributes that are constrained or within the archetyped structure are visible by default).
   */
  visibility?: VISIBILITY_TYPE;
  /**
   * Optional alias for the attribute referenced by the path.
   */
  alias?: openehr_base.Terminology_code;
}

/**
 * Container object for archetype statements relating to RM attributes, which may be directly on objects constrained within the archetype, or at deeper non-constrained RM paths from an object or the root.
 */
export class RM_OVERLAY {
  /**
   * Optional structure in which visibility and aliasing of reference model elements can be specified. Key is path to an RM attribute, which is typically formed from a path to an archetyped node concatenated with a further pure RM attribute path; may also refer to a non-archetyped attribute.
   */
  rm_visibility?: undefined;
}

/**
 * Enumeration of visibility settings for model elements.
 */
export class VISIBILITY_TYPE extends openehr_base.String {
}
